const validateOesophagus=(formData)=>
{
const message0= "NICE recommends:-" 

const dysphagiaMessage="Offer urgent, direct access upper gastrointestinal endoscopy (to be done within 2 weeks) to assess for oesophageal cancer in people with dysphagia"

const urgentEndoscopy= "Offer urgent, direct access upper gastrointestinal endoscopy (to be done within 2 weeks) to assess for oesophageal cancer in people aged 55 and over with weight loss and any of the following: upper abdominal pain, reflux, dyspepsia."

const haematemesisMessage= "Consider non-urgent, direct access upper gastrointestinal endoscopy to assess for oesophageal cancer in people with haematemesis."

const treatmentResistantDysepsia= "Consider non-urgent, direct access upper gastrointestinal endoscopy to assess for oesophageal cancer in people aged 55 or over with treatment‑resistant dyspepsia"

const routOGD="Consider non-urgent, direct access upper gastrointestinal endoscopy to assess for oesophageal cancer in people aged 55 or over with upper abdominal pain with low haemoglobin levels, or raised platelet count with any of the following: (nausea, vomiting, weight loss, reflux, dyspepsia,upper abdominal pain or nausea or vomiting with any of the following (weight loss, reflux, dyspepsia,upper abdominal pain.)"

if (formData.dysphagia)
    {
     formData.investigations.push("Urgent Upper GI Endoscopy")
     formData.message.oesophagus=message0 + dysphagiaMessage
     return formData   
    }

if (formData.age>=55 && formData.weightLoss && (formData.upperAbdoPain || formData.reflux || formData.dyspepsia))
    {
    formData.investigations.push("Urgent Upper GI Endoscopy")
    formData.message.oesophagus=message0 + urgentEndoscopy
    return formData    
    }


if (formData.haematemesis)
    {
    formData.message.oesophagus=routOGD
    formData.investigations.push("Routine Upper GI Endoscopy")
    formData.message.oesophagus=message0 + haematemesisMessage
    return formData      
    }
     
if (formData.age < 55)
    {
    return formData 
    }
if ((formData.upperAbdoPain && (formData.anaemia || formData.idAnaemia)) || 

(formData.thrombocytosis && (formData.nausea || formData.vomiting || formData.weightLoss || formData.reflux || formData.dyspepsia || formData.upperAbdoPain)) ||

((formData.nausea || formData.vomiting) && (formData.weightLoss || formData.reflux || formData.dyspepsia || formData.upperAbdoPain)))
    {
    formData.message.oesophagus=message0 + routOGD
    formData.investigations.push("Routine Upper GI Endoscopy")
    return formData
    }
    
if (formData.dyspepsia)
    {
    formData.message.oesophagus=message0 + treatmentResistantDysepsia
    formData.investigations.push("Routine Upper GI Endoscopy")
    return formData   
    }

return formData
}
    

export default validateOesophagus